import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PermissionsProvider } from './context/PermissionsContext';
import PrivateRoute from './components/PrivateRoute';
import RequirePermission from './components/RequirePermission';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import JobDetails from './pages/JobDetails';
import Resumes from './pages/Resumes';
import ResumeStudio from './pages/ResumeStudio';
import AiStudio from './pages/AiStudio';
import LinkedInStudio from './pages/LinkedInStudio';
import Matches from './pages/Matches';
import Candidates from './pages/Candidates';
import RegisterCandidates from './pages/RegisterCandidates';
import RegisterCandidateDetails from './pages/RegisterCandidateDetails';
import CandidateDetails from './pages/CandidateDetails';
import Timesheets from './pages/Timesheets';
import CrmWorkspace from './pages/CrmWorkspace';
import PublicBookingPage from './pages/PublicBookingPage';
import About from './pages/About';
import Metadata from './pages/Metadata';
import Users from './pages/Users';
import JobScanner from './pages/JobScanner';
import EmailQueue from './pages/EmailQueue';
import AiWatch from './pages/AiWatch';
import ProductAnalytics from './pages/ProductAnalytics';
import Support from './pages/Support';
import SupportNewTicket from './pages/SupportNewTicket';
import Settings from './pages/Settings';
import Layout from './components/Layout';
import { ThemeProvider } from './context/ThemeContext';
import { DialogProvider } from './context/DialogContext';
import './App.css';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ThemeProvider>
        <DialogProvider>
          <AuthProvider>
            <PermissionsProvider>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/about" element={<About />} />
                <Route path="/book/:slug" element={<PublicBookingPage />} />
                <Route
                  path="/*"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <Routes>
                          <Route path="/" element={<RequirePermission><Dashboard /></RequirePermission>} />
                          <Route path="/jobs" element={<RequirePermission><Jobs /></RequirePermission>} />
                          <Route path="/jobs/:id" element={<RequirePermission permission="tab_jobs"><JobDetails /></RequirePermission>} />
                          <Route path="/ai-studio" element={<RequirePermission permission="tab_resumes"><AiStudio /></RequirePermission>} />
                          <Route path="/resumes" element={<RequirePermission><Resumes /></RequirePermission>} />
                          <Route path="/resumes/:id/studio" element={<RequirePermission permission="tab_resumes"><ResumeStudio /></RequirePermission>} />
                          <Route path="/linkedin-studio" element={<RequirePermission permission="tab_resumes"><LinkedInStudio /></RequirePermission>} />
                          <Route path="/matches" element={<RequirePermission><Matches /></RequirePermission>} />
                          <Route path="/candidates" element={<RequirePermission><Candidates /></RequirePermission>} />
                          <Route path="/candidates/:id" element={<RequirePermission permission="tab_candidates"><CandidateDetails /></RequirePermission>} />
                          <Route path="/register" element={<RequirePermission><RegisterCandidates /></RequirePermission>} />
                          <Route path="/register/:id" element={<RequirePermission permission="tab_register"><RegisterCandidateDetails /></RequirePermission>} />
                          <Route path="/timesheets" element={<RequirePermission><Timesheets /></RequirePermission>} />
                          <Route path="/crm" element={<RequirePermission anyOf={['tab_crm']}><CrmWorkspace /></RequirePermission>} />
                          <Route path="/users" element={<RequirePermission><Users /></RequirePermission>} />
                          <Route path="/metadata" element={<RequirePermission><Metadata /></RequirePermission>} />
                          <Route path="/job-scanner" element={<RequirePermission><JobScanner /></RequirePermission>} />
                          <Route path="/email-queue" element={<RequirePermission><EmailQueue /></RequirePermission>} />
                          <Route path="/ai-watch" element={<RequirePermission><AiWatch /></RequirePermission>} />
                          <Route path="/product-analytics" element={<RequirePermission><ProductAnalytics /></RequirePermission>} />
                          <Route path="/support" element={<RequirePermission permission="tab_support"><Support /></RequirePermission>} />
                          <Route path="/support/new" element={<RequirePermission permission="tab_support"><SupportNewTicket /></RequirePermission>} />
                          <Route path="/support/:id" element={<RequirePermission permission="tab_support"><Support /></RequirePermission>} />
                          <Route path="/settings" element={<RequirePermission anyOf={['tab_settings', 'group_manage', 'permission_manage', 'email_manage', 'scanner_manage', 'ai_matching_manage', 'tab_metadata']}><Settings /></RequirePermission>} />
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                      </Layout>
                    </PrivateRoute>
                  }
                />
              </Routes>
            </PermissionsProvider>
          </AuthProvider>
        </DialogProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
